export class Batiment {
	adress: string = "";
	cp: string = "";
	ville: string = "";
	typeRenovation: string = "";
	typeRenovationBis: string = "";
	type: number | undefined;
	anneeConstruction: number | undefined;
	pieces: number | undefined;
	surface: number | undefined;
	nbEtages: number | undefined;
	hauteurPlafond: number | undefined;
	typeChaufage: number | undefined;
	niveauStanding: number | undefined;
	simulationId?: string;
	niveauIsolation?: number;
	mursMitoyens?: number;
	isoPlancher?: number;
	isoPlafonds?: number;
	typeVmc?: number;
	surfacesNiveau?: string = '';
	dpe?: string | null = null;
}
